export const portNamesWithShy = new Map();
portNamesWithShy.set( "Vestmannaeyjar", "Vest&shy;manna&shy;eyjar");
portNamesWithShy.set( "Reydarfjordur", "Reydar&shy;fjordur");
portNamesWithShy.set( "Kollafjordur", "Kolla&shy;fjordur");
portNamesWithShy.set( "Grundartangi", "Grundar&shy;tangi");
portNamesWithShy.set( "Saudarkrokur", "Saudar&shy;krokur");
portNamesWithShy.set( "Immingham", "Imming&shy;ham");
portNamesWithShy.set( "Reykjavik", "Reykja&shy;vik");
portNamesWithShy.set( "Rotterdam", "Rotter&shy;dam");
portNamesWithShy.set( "Cuxhaven", "Cux&shy;haven");
portNamesWithShy.set( "Akureyri", "Akur&shy;eyri");
portNamesWithShy.set( "Varberg", "Var&shy;berg");



// WEBPACK FOOTER //
// ./src/data/portNameCorrection.js